import { MessageFilterItem, MessageNavGroup, MessageNavType } from '../interfaces';
import { reduce, SuiteId } from '@libs/shared';
import { useMemo, useState } from 'react';
import { API } from '../../../constants';
import { getRequestUrl, post } from '../../../utils';

const EMPTY_MESSAGE_FILTERS: MessageFilterItem[] = [];

const useFetchMessageNavGroup = (activeKey?: MessageNavType) => {
    const [messageNavGroup, setMessageNavGroup] = useState<MessageNavGroup>();
    /**
     * 获取消息中心侧边导航栏的消息类型
     * 同时获取右侧消息列表的消息类型筛选项
     */
    const fetchMessageNavGroup = (suiteId?: SuiteId) => {
        setMessageNavGroup(undefined);
        post<MessageNavGroup>(getRequestUrl(API.message.get_menu), {
            suite_id: suiteId
        }).then((res) => {
            setMessageNavGroup(res.data);
        });
    };

    /**
     * 消息列表类型筛选缓存，方便取用，避免重复遍历
     * 把 [{ key: 'a', children: ['1', '2'] }, { key: 'b', children: ['3', '4'] }]
     * 变成 { a: ['1', '2'], b: ['3', '4'] }
     */
    const messageFiltersMap: Record<MessageNavType, MessageFilterItem[]> = useMemo(() => {
        const { suite = [], platform = [] } = messageNavGroup ?? {};
        const messageNavItems = [...suite, ...platform];
        return reduce(
            messageNavItems,
            (filtersMap, current) => {
                filtersMap[current.key] = current.children ?? [];
                return filtersMap;
            },
            Object.create(null)
        );
    }, [messageNavGroup]);

    const messageFilters = activeKey
        ? messageFiltersMap[activeKey] ?? EMPTY_MESSAGE_FILTERS
        : EMPTY_MESSAGE_FILTERS;

    return {
        messageNavGroup,
        messageFilters,
        isFetchingMessageNavGroup: !messageNavGroup,
        fetchMessageNavGroup
    };
};

export default useFetchMessageNavGroup;
